<form >
    <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
 
      <h2 class="headline m-0"  fxFlex="auto">Logs</h2>
        
      <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>
  
    <mat-divider class="-mx-6 text-border"></mat-divider>
  
    <mat-dialog-content fxLayout="column">
      <div class="flex flex-col sm:flex-row py-6">
   
      <mat-form-field class="flex-auto">
        <mat-label>Lines</mat-label>
        <textarea matInput rows="10" >
          {{logData}}
        </textarea>
        <mat-icon [icIcon]="icNotes" class="mr-3" matPrefix></mat-icon>
      </mat-form-field>

      </div>
  
    </mat-dialog-content>
  
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">CLOSE</button>      
    </mat-dialog-actions>
  </form>
  

  
